<template>
  <div style="min-width: 100%">
    <v-row>
      <v-col cols="4" class="d-flex justify-center align-center">
        <h5 class="text-h5">{{fullName}}</h5>
      </v-col>
      <v-col cols="6">
        <v-text-field
            v-model="search"
            append-icon="fa fa-search"
            label="Поиск"
            single-line
            hide-details
            clearable
            outlined
            dense
            class="rounded-xl"
            @click:clear="search = ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="achievements"
      item-key="id"
      :search="search"
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
      single-select
      group-by="prtf_achievement_kind_name"
      class="rounded-xl dashed-outlined"
    >

      <template #item.unit="{item, index}">
        {{ nameUnitTable(item) }}
      </template>

      <template #item.score="{item, index}">
        {{ scoreUnitTable(item) }}
      </template>

      <template #item.file.url="{item, index}">
        <v-btn x-small
               :disabled="urlFileAchievement(item) === null"
               fab
               elevation="0"
               :href="urlFileAchievement(item)"
               :color="$store.state.achievement.side_color"
               target="_blank"
        >
          <v-icon x-small color="white">fa fa-file</v-icon>
        </v-btn>
      </template>

      <template #group.header="{items, isOpen, toggle}">
        <th
          :colspan="headers.length"
          class="header--group-by"
        >
          <div class="text-body-1 d-flex align-center">
            <v-icon small @click="toggle" class="mr-1">{{ isOpen ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
            {{ items[0].prtf_achievement_kind_name }}
          </div>
        </th>
      </template>

      <template #loading>
        Идет загрузка рейтинга...
      </template>
      <template #no-data>
        Отсутствуют достижения
      </template>
      <template #footer>
        <v-row
            v-if="numberOfPages > 1"
            class="pb-5 px-4 pt-5"
            align="center"
            justify="center">
          <div class="text-center">
            <v-pagination
                circle
                :color="$store.state.achievement.side_color"
                v-model="page"
                :length="numberOfPages"
                :total-visible="8">
            </v-pagination>
          </div>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "AchievementsTableAdmin",
  props: {
    achievements: Array,
    fullName: String,
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 7,
      search: "",
      headers: [
        {
          text: 'Группировка',
          value: 'group',
          groupable: false,
          sortable: false,
          width: '1%',
        },
        {
          text: 'Название',
          value: 'name',
          groupable: false,
          sortable: false,
          width: '34%',
        },
        {
          text: 'Ед. измерения',
          value: 'unit',
          groupable: false,
          sortable: false,
          width: '20%',
        },
        {
          text: 'Баллы',
          value: 'score',
          groupable: false,
          sortable: false,
          width: '5%',
        },
        {
          text: 'Дата',
          value: 'date_end',
          groupable: false,
          sortable: false,
          width: '5%',
        },
        {
          text: 'Файл',
          value: 'file.url',
          groupable: false,
          sortable: false,
          width: '5%',
        },
      ],
    }
  },

  computed: {
    numberOfPages () {
      return Math.ceil(this.achievements.length / this.itemsPerPage)
    },
  },

  watch: {
    'page': function () {
      this.scrollTop();
    }
  },

  methods: {
    urlFileAchievement: (achievement) => {return achievement?.file?.url || null},

    nameUnitTable: (item) => {
      const achievement = _.cloneDeep(item);
      if (_.isNull(achievement.unit) && _.isNull(achievement.subunit)) return "Отсутствует"
      if (_.isNull(achievement.subunit)) return achievement.unit.name;
      else return `${achievement.unit.name}/${achievement.subunit.name}`
    },

    scoreUnitTable: (item) => {
      const achievement = _.cloneDeep(item);

      if (_.isNull(achievement.unit) && _.isNull(achievement.subunit)) return "Отсутствует"
      if (_.isNull(achievement.subunit)) return achievement.unit.score
      else return achievement.subunit.score
    },

  }
}
</script>

<style scoped>
.header--group-by {
  background: white;
}
</style>